export default __webpack_public_path__ + "static/media/space-loop-sd.db9c4f85.mp4";